import classNames from "classnames";
import React from "react";

import styles from "./index.module.scss";
interface Props {
  className?: string;
}

const RecommendedBox: React.FC<Props> = ({ className }) => (
  <div className={classNames(styles.recommendedBox, className)}>
    <p className={styles.recommendedText}>RECOMMENDED</p>
  </div>
);

export { RecommendedBox };
